export default __webpack_public_path__ + "static/media/blackslider5.1c1652a5.png";